import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base64 } from "js-base64";
import moment from "moment";
import sha256 from "crypto-js/sha256";
import { Buffer } from "buffer";
import SharePaymentLinkServices from "../Services/SharePaymentLinkServices";
import dayjs from "dayjs";
import "dayjs/plugin/utc";
import { Flex, Spin } from "antd";
const contentStyle = {
  padding: 100,
  background: "rgba(0, 0, 0, 0.2)",
  borderRadius: 4,
};
const content = <div style={contentStyle} />;
dayjs.extend(require("dayjs/plugin/utc"));
function SharePaymentLink(props) {
  const [params, setParams] = useState();

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    let param = getCodeFromURL();
    setParams(param);
  }, []);

  useEffect(() => {
    if (params) {
      callFunction();
    }
  }, [params]);

  const convertUTCDate = (date, format) => {
    if (!format) {
      var d = new Date();
      date = new Date(
        dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return dayjs(date).utc().format(format);
  };
  const callFunction = async () => {
    SharePaymentLinkServices.patientPaymentDetails(params).then((results) => {
      let appointmentDetails =
        results.data[0].transactionId +
        "|" +
        results.data[0].patientId +
        "|" +
        results.data[0].userId +
        "|" +
        results.data[0].serviceTransId +
        "|" +
        results.data[0].account_Id +
        "|" +
        results.data[0].clinic_Id;
      let base64string = Base64.encode(appointmentDetails);
      let paymentPayload = {
        // merchantId: process.env.REACT_APP_PHONEPE_MERCHANT_ID,
        merchantTransactionId: results.data[0].transactionId,
        // merchantUserId: "MUID123",
        amount: parseFloat(results.data[0]?.amount) * 100,
        redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
        redirectMode: "POST",
        callbackUrl: `${process.env.REACT_APP_BASE_URL}/phonePeResponse1/paymentCallBackDetails`,
        mobileNumber: results.data[0].mobile,
        paymentInstrument: {
          type: "PAY_PAGE",
        },
      };

      SharePaymentLinkServices.GetAppointmentId(
        results.data[0].serviceTransId,
      ).then((apptResult) => {
        const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
        const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
        let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
        let base64EncodedPayload = bufferObj.toString("base64");
        let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
        let sha256_val = sha256(string);
        let xVerifyChecksum = sha256_val + "###" + 1;
        let phonepeTransaction = {
          account_Id: results.data[0]?.account_Id,
          checksum: xVerifyChecksum,
          clinic_id: results.data[0]?.clinic_Id,
          createdBy: results.data[0]?.patientId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: results.data[0].userId,
          patientId: results.data[0]?.patientId,
          enoCodePayload: base64EncodedPayload,
          providerreferenceId: "",
          serviceCode: "APPT",
          serviceName: "Appointment Consultation",
          status: 1,
          transactionId: results.data[0].transactionId,
          userId: results.data[0].userId,
          serviceTransId: results.data[0]?.serviceTransId,
          amount: apptResult.data[0]?.totalAmount,
          paymentType: "Share_Link",
        };

        SharePaymentLinkServices.PhonepeTransaction(phonepeTransaction).then(
          (res1) => {
            if (res1.data === 1) {
              let appointmentId = results.data[0]?.serviceTransId;
              SharePaymentLinkServices.GetAppointmentId(appointmentId).then(
                (res2) => {
                  const apptData = res2?.data[0];

                  const isMembership =
                    apptData?.isMembershipDiscount === "Y" ||
                    apptData?.isMembershipDiscount === true;

                  let discountAmnt = 0;
                  if (isMembership) {
                    discountAmnt = parseFloat(apptData?.membershipDiscount) || 0;
                  } else {
                    discountAmnt = parseFloat(apptData?.discountAmount) || 0;
                  }

                  let discountPerc = isMembership
                    ? 0
                    : parseFloat(apptData?.discountPercentage) || 0;

                  let billingTransaction = {
                    account_Id: results.data[0]?.account_Id,
                    amount: apptData?.totalAmount,
                    clinic_id: results.data[0]?.clinic_Id,
                    createdBy: results.data[0]?.patientId,
                    createdDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    discountAmount: discountAmnt,
                    discountPercentage: discountPerc,
                    gst: 0,
                    modifiedBy: results.data[0]?.patientId,
                    modifiedDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    paidAmount: apptData?.totalAmount,
                    patientId: results.data[0]?.patientId,
                    paymentDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    paymode: "PhonePe",
                    serviceCode: "",
                    serviceCost:
                      (apptData?.consultationFee || 0) +
                      (apptData?.patientRegFeeYN === "Y"
                        ? apptData?.patientRegFee || 0
                        : 0),

                    serviceName: "",
                    serviceTransId: apptData?.appointmentId,
                    status: 0,
                    transactionId: results.data[0]?.transactionId,
                    userId: results.data[0]?.userId,
                    billingTransactionServices: [],
                  };

                  let array1 = {
                    account_Id: results.data[0]?.account_Id,
                    amount: apptData?.consultationFee,
                    clinic_id: results.data[0]?.clinic_Id,
                    createdBy: results.data[0]?.patientId,
                    createdDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    modifiedBy: results.data[0]?.patientId,
                    modifiedDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    paidAmount:
                      (apptData?.consultationFee || 0) - discountAmnt,
                    patientId: results.data[0]?.patientId,
                    paymentDate: convertUTCDate(
                      new Date(),
                      "YYYY-MM-DD HH:mm:ss",
                    ),
                    paymode: "PhonePe",
                    serviceCode: "APPT",
                    serviceCost: apptData?.consultationFee,
                    serviceName: "Appointment Consultation",
                    serviceTransId: apptData?.appointmentId,
                    status: 0,
                    toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    transactionId: results.data[0]?.transactionId,
                    userId: results.data[0]?.userId,
                    discountAmount: discountAmnt,
                    discountPercentage: discountPerc,
                  };

                  billingTransaction.billingTransactionServices.push(array1);

                  if (apptData?.patientRegFeeYN == "Y") {
                    let array2 = {
                      account_Id: results.data[0]?.account_Id,
                      amount: apptData?.patientRegFee,
                      clinic_id: results.data[0]?.clinic_Id,
                      createdBy: results.data[0]?.patientId,
                      createdDate: convertUTCDate(
                        new Date(),
                        "YYYY-MM-DD HH:mm:ss",
                      ),
                      fromDate: convertUTCDate(
                        new Date(),
                        "YYYY-MM-DD HH:mm:ss",
                      ),
                      modifiedBy: results.data[0]?.patientId,
                      modifiedDate: convertUTCDate(
                        new Date(),
                        "YYYY-MM-DD HH:mm:ss",
                      ),
                      paidAmount: apptData?.patientRegFee,
                      patientId: results.data[0]?.patientId,
                      paymentDate: convertUTCDate(
                        new Date(),
                        "YYYY-MM-DD HH:mm:ss",
                      ),
                      paymode: "PhonePe",
                      serviceCode: "REG_FEE",
                      serviceCost: apptData?.patientRegFee,
                      serviceName: "Patient Registration Fee",
                      serviceTransId: apptData?.appointmentId,
                      status: 0,
                      toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                      transactionId: results.data[0]?.transactionId,
                      userId: results.data[0]?.userId,
                    };
                    billingTransaction.billingTransactionServices.push(array2);
                  }


                  SharePaymentLinkServices.BillingTransaction(
                    billingTransaction,
                  ).then((res3) => {
                    if (res3.data === 1) {
                      let data1 = {
                        merchantOrderId: results?.data[0].transactionId,
                        amount: parseFloat(res2?.data[0]?.totalAmount) * 100,
                        expireAfter: 1200,
                        metaInfo: {
                          udf1: "Appointment Consultation",
                        },
                        redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
                      };

                      SharePaymentLinkServices.V2initiatePayment(data1).then(
                        (response) => {
                          window.location.replace(response.data.redirectUrl);
                        },
                      );
                    }
                  });
                },
              );
            }
          },
        );
      });
    });
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Makes the container take up the full height of the viewport
        }}
      >
        <Flex align="center" gap="middle">
          <Spin tip="Loading" size="large">
            {content}
          </Spin>
        </Flex>
      </div>
    </>
  );
}

export default SharePaymentLink;
